module.exports = __webpack_public_path__ + "newprotal/img/linkUs.55d391d5.jpg";